export default __webpack_public_path__ + "static/media/logo_full.d2f80e84.png";